"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));
var _CollapseAction = _interopRequireDefault(require("./CollapseAction"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Labels = function Labels(_ref) {
  var _ref$enableCollapse = _ref.enableCollapse,
    enableCollapse = _ref$enableCollapse === void 0 ? false : _ref$enableCollapse,
    header = _ref.header,
    children = _ref.children;
  var _useState = (0, _react.useState)(enableCollapse),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  var childrenArray = _react["default"].Children.toArray(children);
  var isCollapsed = enableCollapse && collapsed;
  return /*#__PURE__*/_react["default"].createElement("div", null, header, /*#__PURE__*/_react["default"].createElement("div", null, childrenArray.slice(0, 4), /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
    "in": !isCollapsed,
    timeout: "auto"
  }, childrenArray.slice(4))), isCollapsed && /*#__PURE__*/_react["default"].createElement(ToggleCollapse, {
    onClick: function onClick() {
      return setCollapsed(false);
    }
  }));
};
var ToggleCollapse = function ToggleCollapse(_ref2) {
  var onClick = _ref2.onClick;
  return /*#__PURE__*/_react["default"].createElement("button", {
    className: "flex items-center h-10"
  }, /*#__PURE__*/_react["default"].createElement(_CollapseAction["default"], {
    onClick: onClick
  }));
};
var _default = exports["default"] = Labels;
//# sourceMappingURL=Labels.js.map